import { Center, Heading, Spinner, VStack } from '@chakra-ui/react'
import { useAdminArticleCtas } from '@olagg/api-hooks'
import { FormArticleCtaData } from '@olagg/validation-schemas/articleCta.schemas'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ROUTES } from '../../consts/routes'
import ArticleCtaForm from './Form'
import { toArticleCtaPayload } from './payload'

const EditArticleCta = () => {
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const { articleCta, find, updateArticleCta } = useAdminArticleCtas({ page: 1, limit: 10 })

  useEffect(() => {
    find(Number(id))
  }, [id])

  const onSubmit = (dataForm: FormArticleCtaData) => {
    updateArticleCta(Number(id), toArticleCtaPayload(dataForm), () => navigate(ROUTES.ARTICLE_CTAS.all))
  }

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>Editar CTA</Heading>
        {articleCta
          ? <ArticleCtaForm onSubmit={onSubmit} articleCta={articleCta} />
          : <Spinner>Cargando...</Spinner>}
      </VStack>
    </Center>
  )
}

export default EditArticleCta
